import {ICategory} from '../types/types';

export function getMatchedCategory(alias: string, data: ICategory[]): ICategory {
    return (data.filter((category: ICategory) => category.alias === alias)[0]);
}
